/**
 * Router which renders views related to user account data.
 * @module app/routers/site/Account/Router
 */
import RouterBase from "app/routers/RouterBase";
import Backbone from "backbone";
import auth from "app/auth";
import urlService from "app/UrlService";
export default RouterBase.extend({
  root: "/auth",

  routes: {
    "auth/logOff": "logOff",
  },

  settings: {
    logOff: {
      title: "Log Off",
    },
  },

  layoutOptions: {
    preserve: true,
  },

  /**
   * Logs the user off, ending the session.
   */
  logOff: async function () {
    Backbone.history.stop();
    return await auth.logout();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/routers/Account.js
// module id = 937
// module chunks = 1